import React, { useEffect, useState } from "react";
import { useTerms } from "../../services/terms/terms.service";
import { ITermItemResponse } from "../../services/terms/terms.interface";
import { ContentPage, Loading } from "../../components";

const Landing = () => {
  const { termsData, loading } = useTerms();
  const [contentPage, setContentPage] = useState<ITermItemResponse>();

  useEffect(() => {
    if (termsData) {
      const data = termsData.terms?.find((e) => e.content?.id === "1");

      setContentPage(data);
    }
  }, [termsData]);

  if (loading) {
    return <Loading centerAll />;
  }

  return (
    <>
      {contentPage ? (
        <ContentPage content={contentPage} />
      ) : null}
    </>
  );
};

export default Landing;
